<template>
  <div style="display: contents">
    <CommonEdit :company="company" :companies="companies" />
    <tr style="opacity: 0.6">
      <td colspan="2">
        Поля ОПФ
      </td>
    </tr>
    <tr>
      <td class="label-col">Номер ОГРН</td>
      <td>
        <input
          v-model="company.ogrn"
          type="text"
          class="form-control"
          placeholder
          required
        >
      </td>
    </tr>
    <tr>
      <td class="label-col">Номер КПП</td>
      <td>
        <input
          v-model="company.kpp"
          type="text"
          class="form-control"
          placeholder
          required
        >
      </td>
    </tr>
    <tr>
      <td class="label-col">В лице</td>
      <td>
        <input
          v-model="company.manager"
          type="text"
          class="form-control"
          placeholder
          required
        >
      </td>
    </tr>
    <tr>
      <td class="label-col">Должность</td>
      <td>
        <input
          v-model="company.position"
          type="text"
          class="form-control"
          placeholder
          required
        >
      </td>
    </tr>
  </div>
</template>


<script>
import CommonEdit from '@/views/companies/common/Edit'

export default {
  name: 'LlcEdit',
  components: {
    CommonEdit
  },
  props: {
    company: {
      type: Object,
      default: null
    },
    companies: {
      type: Array,
      default: null
    },
  },
  watch: {
    data: {
      handler () {
        this.$emit('update', {
          ...this.company
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
